import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')<{
    $noGutter?: boolean;
    $isMBTOptimization?: boolean;
}>`
    margin: ${({ $noGutter, $isMBTOptimization }) =>
        $noGutter ? '0' : $isMBTOptimization ? '2.5rem 0 0 0' : '2rem 0'};
`;
